
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PERMISSION } from '@/permissions';
import { Action, Getter } from 'vuex-class';
import Toast from '@/utils/toast';
import CsvImportModal from '@/components/menu/CsvImportModal.vue';
import IconButton from '@/components/shared/suites/IconButton.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';
import ModalWrapper from '@/components/shared/ModalWrapper.vue';
import Search from '@/components/shared/Search.vue';
import WarningModal from '@/components/shared/suites/WarningModal.vue';
import TextField from '@/components/shared/TextField.vue';

const namespace: string = 'auth';

@Component<EditMenusSubheader>({
	components: {
		TextField,
		CsvImportModal,
		IconButton,
		ModalWrapper,
		Search,
		TextButton,
		WarningModal
	}
})
export default class EditMenusSubheader extends Vue {
	@Action('searchContent', { namespace: 'search' }) private searchContent!: (searchString: string | null) => Promise<void>;
	@Action('pullMenus', { namespace: 'menus' }) private pullMenus!: (payload: any) => Promise<Menu[]>;
	@Getter('getTenantId', { namespace }) private tenantId!: Restaurant;
	@Getter('isPosIntegrated', { namespace }) private isPosIntegrated!: boolean;
	@Getter('hasPermission', { namespace }) private hasPermission!: (permission: PERMISSION) => boolean;
	@Getter('isCsvImportEnabled', { namespace }) private csvImportEnabled!: boolean;
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;
	@Prop({ type: String, required: true }) private component!: string;

	private PERMISSION = PERMISSION;
	private showSearchDialog: boolean = false;
	private showCsvImportModal: boolean = false;
	private showWarningModal: boolean = false;

	private get buttonText(): string {
		return this.component === 'menu' ? this.$t('menu.create_btn') : this.$t(`menu.${this.component}.create_btn`);
	}

	/**
	 * Close the search modal
	 *
	 * @return {void}
	 */
	private closeSearchDialog(): void {
		this.searchContent(null);
		this.showSearchDialog = false;
	}

	/**
	 * Pull menu(s)
	 *
	 * @return {void}
	 */
	private async menuPull(): Promise<void> {
		this.showWarningModal = false;

		try {
			await this.pullMenus({ id: this.tenantId, name: this.restaurant.name, pullAll: false });
			Toast.success(this.$t('menu.pull.success_menu_pull'));
		}
		catch (error) {
			Toast.error(this.$t('menu.pull.error_menu_pull'));
		}
	}
}
